import Commons from '../../../Services/Common/Common';

export const M_NOT_BASIC_01_Schema = {
  mapper: {
    search1: {
      ChaebunNo: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
    search2: {
      ChaebunNo: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
    delete1: {
      ChaebunNo: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
  },
};
